class RelateProductSlide extends HTMLElement {
  constructor() {
    super();
    this.Slide = this.querySelector('.js-related-product-slide');
    this.swiperRelateProductSlide = new Swiper(this.Slide, {
      loop: true,
      pagination: {
        el: ".related-products__pagination",
        type: "progressbar",
        clickable: true
      },
      navigation: {
        nextEl: ".related-products__button-next",
        prevEl: ".related-products__button-prev",
      },
      loop: false,
      slidesPerView: 2,
      centeredSlides: false,
      spaceBetween: 15,
      breakpoints: {
        990: {
          slidesPerView: 4,
          spaceBetween: 24
        },
        1140: {
          slidesPerView: 6,
          spaceBetween: 24
        }
      }
    });
  }
}
customElements.define("related-product-slide", RelateProductSlide);